import * as React from 'react';

/**
 * @return {React.ReactElement}
 * @constructor
 */
export default function ActiveFolder(): React.ReactElement {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#active_folder)">
        <path d="M16.2225 4.96985H1.77745C0.795055 4.97567 0.00146683 5.77319 0.000496296 6.75563C-0.000165432 6.7656 -0.000165432 6.77566 0.000496296 6.78563L1.03279 14.4881C1.04532 15.4657 1.84089 16.2519 2.81857 16.2527H15.1885C16.1661 16.2519 16.9617 15.4657 16.9742 14.4881L17.9995 6.78563C18.0001 6.77566 18.0001 6.7656 17.9995 6.75563C17.9986 5.77319 17.205 4.97567 16.2225 4.96985Z" />
        <path d="M14.9047 3.19111H9.10263L7.95564 1.82707C7.91219 1.77484 7.84707 1.74555 7.77918 1.74767H3.09592C2.36541 1.74864 1.77343 2.34062 1.77246 3.07112V4.3434H2.21361H16.2158C16.1299 3.68467 15.5689 3.19173 14.9047 3.19111Z" />
      </g>
      <defs>
        <clipPath id="active_folder">
          <rect width="18" height="18"  transform="translate(0 0.00012207)"/>
        </clipPath>
      </defs>
    </svg>
  );
}
